import React from 'react';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

import SheetContainer, {
    CloseButton,
    Content,
    Header,
    Heading,
    Overlay,
    Sheet,
} from '../../../../../../mobile/structural/sheet';
import TagEditContent from '../edit/TagEditContent';

import { TAGS_SHEET_DEFAULT_SNAP_POINT } from './MobileTagsSheet';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

type MobileTagEditSheetProps = {
    sheetProps: UseSheetReturnType;
    tag: Tag | null;
    shareRootPath: ImMNElement[];
    closePopup: () => void;
};

const MobileTagEditSheet: React.FC<MobileTagEditSheetProps> = ({ sheetProps, tag, shareRootPath, closePopup }) => {
    const translate = useTranslator('popup', 'tags.edit');

    if (!tag) return null;

    return (
        <SheetContainer
            className="tags-more"
            {...sheetProps}
            defaultSnapPoint={TAGS_SHEET_DEFAULT_SNAP_POINT}
            snapPoints={[0.5, 0.9]}
        >
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>{translate('heading')}</Heading>
                    <CloseButton />
                </Header>
                <Content>
                    <div className="p-5">
                        <TagEditContent tag={tag} shareRootPath={shareRootPath} closePopup={closePopup} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileTagEditSheet;
